import { defineComponent as _defineComponent } from 'vue'

import { Tooltip } from 'element-ui';

const __default__ = {
  components: {
    [Tooltip.name]: Tooltip,
  },
};

import { computed } from 'vue';

interface Tag {
  id: number;
  name: string;
  color: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TagDots',
  props: {
  tags: { type: Array as () => Tag[], required: true },
  max: { type: Number, default: 3 },
},
  emits: ['click'],
  setup(__props) {

const props = __props





const visibleTags = computed(() => props.tags.slice(0, props.max));
const overflowCount = computed(() => Math.max(0, props.tags.length - props.max));

return { __sfc: true,props, visibleTags, overflowCount }
}

})